const proceduresReducer = (
  state = {
    loading: false,
    data: null,
    procedureHistory: null,
    offlineProcedureHistory: null,
    selectedProcedure: null
  },
  action
) => {
  switch (action.type) {
    case "SET_PROCEDURES_LOADING":
      return {
        ...state,
        loading: action.payload.loading
      };

    case "SET_PROCEDURES_DATA":
      return {
        ...state,
        data: action.payload.data
      };

    case "SET_PROCEDURES_HISTORY_DATA":
      return {
        ...state,
        procedureHistory: action.payload.data
      };

    case "PUT_OFFLINE_PROCEDURES_HISTORY":
      return {
        ...state,
        offlineProcedureHistory: action.payload
      };

    case "SET_SELECTED_PROCEDURE":
      return {
        ...state,
        selectedProcedure: action.payload.data
      };

    case "RESET":
      return {
        loading: false,
        data: null,
        procedureHistory: null,
        offlineProcedureHistory: null,
        selectedProcedure: null
      };

    default:
      return state;
  }
};
export default proceduresReducer;
